import { useEffect, useMemo, useState } from 'react';

const normalizeType = (item) =>
    String(item?.marketplace_type || item?.type || item?.marketplace || '').toLowerCase();

export const getWbAccounts = (marketplaces) =>
    marketplaces.filter((item) => normalizeType(item).includes('wildberries') || normalizeType(item).includes('wb'));

export function useWbState({ activeMarketplace, marketplaces }) {
    const [wbAccountId, setWbAccountId] = useState(null);

    const wbAccounts = useMemo(() => getWbAccounts(marketplaces), [marketplaces]);

    const activeAccount = useMemo(
        () => wbAccounts.find((acc) => acc.id === wbAccountId) || null,
        [wbAccounts, wbAccountId]
    );

    const wbAccountName = activeAccount?.account_name || activeAccount?.name || '';

    // Reset if account no longer exists
    useEffect(() => {
        if (wbAccountId && !wbAccounts.some((a) => a.id === wbAccountId)) {
            setWbAccountId(null);
        }
    }, [wbAccountId, wbAccounts]);

    // Auto-select first WB account when switching to wildberries
    useEffect(() => {
        if (activeMarketplace === 'wildberries') {
            if (!wbAccountId && wbAccounts.length > 0) {
                setWbAccountId(wbAccounts[0].id);
            }
        }
    }, [activeMarketplace, wbAccountId, wbAccounts]);

    const wbSectionProps = {
        wbAccountId,
        wbAccountName,
        wbAccounts,
        setWbAccountId
    };

    return { wbSectionProps };
}
